<h1 mat-dialog-title>Edit Signature Matrix Type</h1>
<div mat-dialog-content appUserManual [userManualKey]="'edit-signature-matrix-dialog'">
  <mat-form-field>
    <mat-label>Signature Matrix Type</mat-label>
    <input matInput [(ngModel)]="data.checkSheet.signatureMatrixType" [matAutocomplete]="auto" />
    <mat-autocomplete #auto="matAutocomplete">
      @for (type of data.signatureMatrixTypes; track type) {
        <mat-option [value]="type">
          {{ type }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button (click)="onSave()">Save</button>
</div>
